// extracted by mini-css-extract-plugin
export var Tags = "tags-module--Tags--2AzzR";
export var Tags__item = "tags-module--Tags__item--2HYL6";
export var Tags__item_active = "tags-module--Tags__item_active--1YiKz";
export var Tags__more = "tags-module--Tags__more--2BwrF";